import { render, staticRenderFns } from "./Referral.vue?vue&type=template&id=0c338400&scoped=true"
import script from "./Referral.vue?vue&type=script&lang=ts"
export * from "./Referral.vue?vue&type=script&lang=ts"
import style0 from "./Referral.vue?vue&type=style&index=0&id=0c338400&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c338400",
  null
  
)

export default component.exports